import React, { useState } from 'react';
import { useCustomContext } from '../CustomComponents/CustomComponents';
import { AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import UserPool from '../../UserPool';
import { insertLog } from '../Logs/InsertLog';

const UpdatePasswordLogic = () => {
    const [isLoading, setLoading] = useState(false);
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMessages, setErrorMessages] = useState({});
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const { showToast, hud, stopHudRotation, showAlert } = useCustomContext();
    const email = localStorage.getItem("email");
    const userName = email?.split('@')[0];
    // Regex patterns for password validation
    const lengthRegex = /^.{8,}$/;
    const numberRegex = /\d/;
    const symbolRegex = /[!@#$%^&*(),.?":{}|<>]/;
    const uppercaseRegex = /[A-Z]/;
    const lowercaseRegex = /[a-z]/;

    // Validate old password function
    const validateOldPassword = () => {
        let errors = {};
        if (!oldPassword || oldPassword.length < 8 ||
            !lengthRegex.test(oldPassword) ||
            !numberRegex.test(oldPassword) ||
            !symbolRegex.test(oldPassword) ||
            !uppercaseRegex.test(oldPassword) ||
            !lowercaseRegex.test(oldPassword)
        ) {
            errors.oldPassword = 'Password must contain at least 8 characters including numbers, symbols, uppercase, and lowercase letters.';
        }
        return errors;
    };

    // Validate new password function
    const validateNewPassword = () => {
        let errors = {};
        if (!newPassword) {
            errors.newPassword = 'New password is required.';
        } else {
            if (
                !lengthRegex.test(newPassword) ||
                !numberRegex.test(newPassword) ||
                !symbolRegex.test(newPassword) ||
                !uppercaseRegex.test(newPassword) ||
                !lowercaseRegex.test(newPassword)
            ) {
                errors.newPassword = 'Password must contain at least 8 characters including numbers, symbols, uppercase, and lowercase letters.';
            }
            if (newPassword === oldPassword) {
                errors.newPassword = 'New password must be different from old password.';
            }
        }

        if (newPassword !== confirmPassword) {
            errors.confirmPassword = 'Passwords do not match.';
        }

        return errors;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Validate passwords
        const oldPasswordErrors = validateOldPassword();
        const newPasswordErrors = validateNewPassword();
        const errors = { ...oldPasswordErrors, ...newPasswordErrors };

        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            stopHudRotation();
            return;
        }

        if (!email) {
            showToast({ message: "email not found in local storage" });
            setLoading(false);
            return;
        }
        const userData = {
            Username: email,
            Pool: UserPool,
        };


        const cognitoUser = new CognitoUser(userData);

        // Authenticate user
        const authenticationDetails = new AuthenticationDetails({
            Username: email,
            Password: oldPassword,
        });

        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: () => {
                setLoading(true);
                // Change password after authentication
                cognitoUser.changePassword(oldPassword, newPassword, (err, result) => {
                    setLoading(false);
                    stopHudRotation();

                    if (err) {
                        showToast({ message: `Error changing password: ${err.message}` });
                        return;
                    }

                    showToast({ message: "Password changed successfully!" });
                    localStorage.removeItem("rememberedPassword");
                    setOldPassword("");
                    setNewPassword("");
                    setConfirmPassword("");
                    setErrorMessages({});
                });
                insertLog(
                    `${userName} updated their password`,
                    0,
                    email,
                    hud,
                    stopHudRotation,
                    showAlert
                );
            },
            onFailure: (err) => {
                setLoading(false);
                stopHudRotation();
                setErrorMessages({});
                showToast({ message: `Authentication failed: ${err.message}` });
            },
        });
    };

    const handleCancel = () => {
        setNewPassword('');
        setOldPassword('');
        setConfirmPassword('');
        setErrorMessages({});
    };
    return (
        {
            isLoading,
            showOldPassword,
            setShowOldPassword,
            showNewPassword,
            setShowNewPassword,
            showConfirmPassword,
            setShowConfirmPassword,
            handleCancel,
            handleSubmit,
            errorMessages,
            hud,setOldPassword,
            oldPassword,
            newPassword,setNewPassword,
            confirmPassword,setConfirmPassword
        }
    )
}

export default UpdatePasswordLogic